import { render, staticRenderFns } from "./chartColumnInvestorStructure.vue?vue&type=template&id=831d4e50&scoped=true"
import script from "./chartColumnInvestorStructure.vue?vue&type=script&lang=js"
export * from "./chartColumnInvestorStructure.vue?vue&type=script&lang=js"
import style0 from "./chartColumnInvestorStructure.vue?vue&type=style&index=0&id=831d4e50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "831d4e50",
  null
  
)

export default component.exports